// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-switcher-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: 36px;
}
.tenant-switcher-btn .chevron {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-inline-start: 0.25rem;
  opacity: 0.6;
}

.active-check {
  margin-inline-start: auto;
  color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/app/layout/components/tenant-switcher/tenant-switcher.component.ts"],"names":[],"mappings":"AACM;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAAR;AACQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,YAAA;AACV;;AAEM;EACE,yBAAA;EACA,2BAAA;AACR","sourcesContent":["\n      .tenant-switcher-btn {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.4rem;\n        height: 36px;\n        .chevron {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n          margin-inline-start: 0.25rem;\n          opacity: 0.6;\n        }\n      }\n      .active-check {\n        margin-inline-start: auto;\n        color: var(--primary-color);\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
